const getInstagramName = (text: string): string => {
  if (!text) {
    return text;
  }

  const regxp = /instagram\.com\/(.*)/i;
  const match = text.match(regxp);
  const result = (match || [])[1] ?? text;

  return result.trim().replace(/\//, '');
};

export default getInstagramName;
